module.exports = __webpack_public_path__ + "img/vr-chemistry-lab-desktop.f9e8f066.jpg";